import $ from 'jquery';
import Chaplin from 'chaplin';
import LocaleService from 'services/loader-handler-services/locale-service';

class HyperlinkService {
  constructor() {
    this.data = {};
    this.blocks = [];
    Chaplin.mediator.subscribe('link:clicked', this.clickHandler, this);
    Chaplin.mediator.subscribe('button:clicked', this.clickHandler, this);
    Chaplin.mediator.subscribe('page:state:initialized', this.reset, this);
  }

  reset() {
    this.blocks.length = 0;
  }

  clickHandler(attrs, blockView) {
    const { data, id } = attrs;
    if (!data) {
      return false;
    }
    switch (data.actiontype) {
      case 'navigate':
        this.navigate(data, blockView);
        break;
      case 'execute':
        this.execute(data, blockView);
        break;
      case 'open_modal':
        this.openModal(data, blockView);
        break;
      case 'action':
        this.dispatchAction(id, data, blockView);
        break;
      case 'close_content':
        this.closeContent(data);
        break;
      case 'scroll':
        this.scrollTo(data);
        break;
      case 'audio_playback':
        this.handleAudio(blockView);
        break;
      default:
        console.warn(`Action type: ${data.actiontype} is currently not supported`);
        break;
    }
  }

  registerBlock(block) {
    this.blocks.push(block);
  }

  closeContent(data) {
    if (data.safeExit) {
      window.postMessage(
        {
          event_type: 'safety-exit',
          redirectUrl: data.redirect || '',
        },
        window.location.origin
      );
    } else {
      window.postMessage({ event_type: 'close-content' }, window.location.origin);
    }
  }

  execute(data, blockView) {
    blockView.script[data.target]();
  }

  handleAudio(blockView) {
    const action = blockView.$el.find('[data-actiontype="audio_playback"]').attr('data-action');
    const audio_id = document.querySelector('.audio__player').id;
    if (action === 'play') {
      blockView.publishEvent(`audio:play:${audio_id}`, { user_initiated: true });
    } else {
      blockView.publishEvent('audio:stop', { user_initiated: true });
    }
  }

  updateAudioButtonState(blockView, state) {
    const $button = blockView.$el.find('[data-actiontype="audio_playback"]');
    const $description = blockView.$el.find('.description');
    const $icon_play = blockView.$el.find('.qs-icon-play');
    const $icon_stop = blockView.$el.find('.qs-icon-stop');
    if (state === 'play') {
      const stop_text = blockView.model.get('stop_text') || 'audio.playStatus';
      $button.attr('data-action', 'stop');
      $description.html(LocaleService.t(stop_text));
      $icon_play.hide();
      $icon_stop.show();
    } else {
      const play_text = blockView.model.get('play_text') || 'listen';
      $button.attr('data-action', 'play');
      $description.html(LocaleService.t(play_text));
      $icon_stop.hide();
      $icon_play.show();
    }
  }

  dispatchAction(id, data, blockView) {
    Chaplin.mediator.publish(
      `button:clicked:${data.target}`,
      {
        buttonId: id || data.trigger,
        target: data.target,
        action: data.action,
      },
      blockView,
      blockView.pageView
    );
  }

  openModal(data, blockView) {
    Chaplin.mediator.publish(
      `button:clicked:${data.target}`,
      {
        target: data.target,
        action: data.action,
        buttonId: data.buttonId,
      },
      blockView,
      blockView.pageView
    );
  }

  navigate(data, blockView) {
    const navigateType = data.navigate;
    switch (navigateType) {
      case 'complete':
        Chaplin.mediator.publish('page:complete', { direction: 'forward' });
        break;
      case 'completeme':
        if (!blockView.completed) {
          blockView.completed = true;
          blockView.readyToGo();
        }
        break;
      case 'window':
        Chaplin.mediator.publish('window:navigate', data.windowNavigate);
        break;
      case 'new_window':
        window.open(data.windowNavigate, '_blank');
        break;
      default:
        Chaplin.mediator.publish('page:navigate', navigateType);
        break;
    }
  }

  scrollTo(data) {
    const $scrollPane = $(data.scrollPane);
    const $scrollTarget = $(data.target);
    const offsetTop = Number.parseInt(data.offsetTop);

    const result = $scrollTarget.offset().top + offsetTop;

    $scrollPane.animate({ scrollTop: result }, 500);
  }
}

const hyperlinkService = new HyperlinkService();

export { hyperlinkService, HyperlinkService };
